import { useEffect } from "react";

/**
 * Pins the ApexCharts left Y-axis in place during horizontal scrolling.
 */
export function useStickyYAxis(
  scrollWrapperRef: React.RefObject<HTMLDivElement | null>,
  chartRef: React.RefObject<HTMLDivElement | null>,
  isScrollable: boolean,
) {
  useEffect(() => {
    const wrapper = scrollWrapperRef.current;
    const chart = chartRef.current;
    if (!wrapper || !chart || !isScrollable) return;

    const onScroll = () => {
      const yaxis = chart.querySelector<SVGGElement>(".apexcharts-yaxis");
      if (!yaxis) return;

      if (!yaxis.dataset.initialX) {
        const match = (yaxis.getAttribute("transform") || "").match(
          /translate\(\s*([-\d.]+)/,
        );
        yaxis.dataset.initialX = match ? match[1] : "0";
      }

      const initX = parseFloat(yaxis.dataset.initialX) || 0;
      // Remove any previously injected background if present
      const oldBg = yaxis.querySelector(".apexcharts-yaxis-bg");
      if (oldBg) oldBg.remove();

      yaxis.setAttribute("transform", `translate(${initX + wrapper.scrollLeft}, 0)`);
    };

    wrapper.addEventListener("scroll", onScroll, { passive: true });
    return () => wrapper.removeEventListener("scroll", onScroll);
  }, [scrollWrapperRef, chartRef, isScrollable]);
}
